export default __webpack_public_path__ + "static/media/bank.677d6081.ttf";